export function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

export function extractFields(jsonString, ...fields) {
  try {
    const parsed = JSON.parse(jsonString);

    const result = {};
    fields.forEach(key => {
      result[key] = parsed[key] || "";
    });

    return result;
  } catch (err) {
    console.error("Error parsing JSON:", err);

    // return empty values for all requested fields
    const emptyResult = {};
    fields.forEach(key => (emptyResult[key] = ""));
    return emptyResult;
  }
}
